export default "__VITE_ASSET__csGqcLqE__"